import InterfaceRuleSpecification from './InterfaceRuleSpecification'

export default class AbstractRuleSpecification extends InterfaceRuleSpecification {
  constructor () {
    super()

    if (new.target === AbstractRuleSpecification) {
      throw new TypeError('Cannot construct Abstract instances directly')
    }

    this._reasonNotSatisfied = ''
    this._reasonsNotSatisfied = []
  }

  isSatisfiedBy (entity) {
    this._clearReasonsNotSatisfied()

    if (this._executeCheckIsSatisfiedBy(entity)) {
      return true
    }

    this.addReasonNotSatisfied()

    return false
  }

  _clearReasonsNotSatisfied () {
    this._reasonsNotSatisfied = []
  }

  /**
   * @private
   *
   * @param entity
   *
   * @return boolean
   */
  _executeCheckIsSatisfiedBy (entity) {}

  /**
   *
   */
  addReasonNotSatisfied () {
    this._reasonsNotSatisfied.push(this._reasonNotSatisfied)
  }

  /**
   *
   * @param reasons
   */
  addReasonsNotSatisfiedBy (reasons = []) {
    this._reasonsNotSatisfied = this._reasonsNotSatisfied.concat(reasons)
  }

  /**
   *
   * @return {[]|*[]}
   */
  getReasonsNotSatisfied () {
    return this._reasonsNotSatisfied
  }

  getReasonsNotSatisfiedAsString (separator = ', ') {
    return this._reasonsNotSatisfied.join(separator)
  }
}
